"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var eventsHelper_1 = require("../utils/eventsHelper");
var Accordion = /** @class */ (function () {
    function Accordion(rootElement) {
        eventsHelper_1.default.live('.js-accordion-trigger', eventsHelper_1.default.clickOrTouchEvent, function (event, clickedElement) {
            event.preventDefault();
            if (!clickedElement) {
                return;
            }
            if (!clickedElement.parentNode.classList.contains('is-open')) {
                rootElement.querySelectorAll('.js-accordion-trigger').forEach(function (item, index) {
                    item.parentNode.classList.remove('is-open');
                });
                clickedElement.parentNode.classList.add('is-open');
            }
            else {
                clickedElement.parentNode.classList.remove('is-open');
            }
        }, rootElement);
    }
    return Accordion;
}());
exports.default = Accordion;
